export default [
	{ id: 'ONE', question: 'Moves ULD in Steady Motion' },
	{ id: 'TWO', question: 'Has Assistance with Full ULDs' },
	{ id: 'THREE', question: 'Faces Forward' },
	{ id: 'FOUR', question: 'Squares Up Pushing' },
	{ id: 'FIVE', question: 'Knocks Container' },
	{ id: 'SIX', question: 'Scans Path in Motion' }
]
